export default __webpack_public_path__ + "static/media/logo-arshad.a231710b.png";